import { render, staticRenderFns } from "./ActivitySupportRequest.vue?vue&type=template&id=061ba9b3"
import script from "./ActivitySupportRequest.vue?vue&type=script&lang=ts"
export * from "./ActivitySupportRequest.vue?vue&type=script&lang=ts"
import style0 from "./ActivitySupportRequest.vue?vue&type=style&index=0&id=061ba9b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports